import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class SnackbarService {
  private readonly ACTION = 'Cerrar';

  constructor(private snackBar: MatSnackBar) {}

  success(message: string, duration = 3000): void {
    this.open(message, duration, 'snack-success');
  }

  error(message: string, duration = 4000): void {
    this.open(message, duration, 'snack-error');
  }

  warning(message: string, duration = 3500): void {
    this.open(message, duration, 'snack-warning');
  }

  info(message: string, duration = 3000): void {
    this.open(message, duration, 'snack-info');
  }

  private open(message: string, duration: number, panelClass: string): void {
    const config: MatSnackBarConfig = {
      duration,
      panelClass: ['snack-base', panelClass],
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    };
    this.snackBar.open(message, this.ACTION, config);
  }
}
